import { Avatar, Box } from "@mui/material";
import stringToColor from "../utils/string-to-color";

const renderAvatar = (classroom_id: number, name: string, image?: string | File, mobile: number = 32, desktop: number = 32) => {
  let imageUrl: string | undefined;
  
  // Handle File object
  if (image instanceof File) {
    imageUrl = URL.createObjectURL(image);
  } 
  // Handle string URL (check if it's a valid non-empty string)
  else if (typeof image === 'string' && image.trim() !== '') {
    imageUrl = `https://d1at3arxf72ma9.cloudfront.net/classrooms/${classroom_id}/class_images/${image}`;
  }

  // If we have an image (either from file or URL), render it
  if (imageUrl) {
    return (
      <Avatar
        src={imageUrl}
        alt={name}
        sx={{
          width: { xs: mobile, md: desktop },
          height: { xs: mobile, md: desktop },
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
    );
  }

  // Fallback to initials avatar
  const initials = name
    .split(" ")
    .map((word) => word[0])
    .join("")
    .toUpperCase()
    .slice(0, 2);


  return (
    <Avatar
      sx={{
        width: { xs: mobile, md: desktop },
        height: { xs: mobile, md: desktop },
        borderRadius: "50%",
        backgroundColor: stringToColor(name),
        color: "white",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        fontSize: { xs: mobile / 3, md: desktop / 3 },
        fontWeight: 600,
      }}
    >
      {initials}
    </Avatar>
  );
};

export default renderAvatar;